import constant from '../../store/constant'
var utils = require('../../utils')

export default {
  name: 'sips-clinic-list',
  data: function () {
    return {
      shopId: null,
      clinicId: null,
      clinicName: null,
      nsClinicCode: null,
      nsClinicName: null,
      searchClinicName: null,
      nsClinicLoading: true,
      clinicLoading: true,
      firstLoading: true
    }
  },
  beforeRouteLeave (to, from, next) {
    utils.scrollBottomSearchEventRemove() // 最下部スクロールイベント削除
    this.$store.dispatch('NS_CLINIC_AUTOCOMPLETE_CLEAR', 0)
    next()
  },
  created: function () {
    if (this.$store.getters.canManage) {
      this.shopId = this.$store.getters.currentShopId
    }
    this.getNsClinics(false)
    this.search()
    if(this.$router.currentRoute.query.clinic_code != null && this.$router.currentRoute.query.clinic_name != null){
      this.nsClinicCode = this.$router.currentRoute.query.clinic_code
      this.nsClinicName = this.$router.currentRoute.query.clinic_name
    }
    utils.scrollBottomSearchEvent(this.getClinics, true, 'button.next-page-search-btn')
  },
  computed: {
    shops () {
      return this.$store.getters.shops
    },
    clinics () {
      return this.$store.getters.clinics
    },
    nsClinics () {
      return this.$store.getters.ns_clinics
    },
    currentPage () {
      return this.$store.getters.clinicsCurrentPage
    },
    nextPage () {
      return this.$store.getters.clinicsNextPage
    }
  },
  methods: {
    search: function () {
      self = this
      this.$store.dispatch('SHOP_SEARCH', {data: { all_get: true }, 'allShopName': this._self.$t('AllShopName'), callback: () => {
        self.getClinics(false)
      }})
    },
    getClinics: function (readMore) {
      var self = this
      var url = null

      if (readMore) {
        url = this.$store.getters.clinicsNextPage
      }
      self.clinicLoading = true
      this.$store.dispatch('CLINIC_SEARCH', { url: url, data: {'clinic_name': self.searchClinicName, 'shop_id': self.shopId}, callback: () => {
        self.clinicLoading = false
      }})
    },
    getNsClinics: function () {
      self = this
      if (self.firstLoading) {
        self.nsClinicCode = null
        self.nsClinicLoading = true
        this.$store.dispatch('NS_CLINICS_SEARCH', { data: { shop_id: self.shopId }, callback: () => {
          self.nsClinicLoading = false
        }})
        self.firstLoading = false
      }
    },
    matching: function () {
      self = this
      self.firstLoading = true
      this.$store.dispatch('NS_CLINIC_MATCHING', { data: { 'clinic_id': this.clinicId, 'medical_institution_reception_code': this.nsClinicCode }, callback: () => {
        this.getNsClinics()
        self.search()
      }})
    },
    createClinic: function () {
      if (this.nsClinicCode !== null) {
        this.$router.push({ path: '/clinics/edit', query: { type: 'select_facility', nsips: 'clinic', clinic_code: this.nsClinicCode } })
      } else {
        return false
      }
    },
    setNsClinicName: function (nsClinicName) {
      this.nsClinicName = nsClinicName
    },
    setClinicData: function (id, clinicName) {
      this.clinicId = id
      this.clinicName = clinicName
    },
    unsetClinicData: function () {
      this.clinicId = null
      this.clinicName = null
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/nsips-clinic-list.js